import RenderIf from "Components/Structure/RenderIf"
import React from "react"


const TemplateIcon = () => {
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        fill="none"
        viewBox="0 0 20 20"
        stroke={"currentColor"}
        >
            <path d="M1 2.125C1 1.50368 1.50368 1 2.125 1H17.875C18.4963 1 19 1.50368 19 2.125V4.375C19 4.99632 18.4963 5.5 17.875 5.5H2.125C1.50368 5.5 1 4.99632 1 4.375V2.125Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M1 11.125C1 10.5037 1.50368 10 2.125 10H8.875C9.49632 10 10 10.5037 10 11.125V17.875C10 18.4963 9.49632 19 8.875 19H2.125C1.50368 19 1 18.4963 1 17.875V11.125Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14.5 11.125C14.5 10.5037 15.0037 10 15.625 10H17.875C18.4963 10 19 10.5037 19 11.125V17.875C19 18.4963 18.4963 19 17.875 19H15.625C15.0037 19 14.5 18.4963 14.5 17.875V11.125Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

const CustomizeIcon = () => {
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        fill="none"
        viewBox="0 0 26 26"
        stroke={"currentColor"}
        >
            <path d="M13.0001 19.7394C16.7224 19.7394 19.7399 16.7219 19.7399 12.9996C19.7399 9.27729 16.7224 6.25977 13.0001 6.25977C9.27778 6.25977 6.26025 9.27729 6.26025 12.9996C6.26025 16.7219 9.27778 19.7394 13.0001 19.7394Z"  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M23.5912 12.0372L24.8317 10.1765C24.9125 10.0566 24.966 9.92038 24.9883 9.77752C25.0105 9.63466 25.0011 9.48865 24.9606 9.34986C24.7266 8.57924 24.4181 7.83321 24.0396 7.12231C23.9703 6.99576 23.8739 6.88608 23.7573 6.80109C23.6407 6.71611 23.5067 6.65792 23.365 6.63068L21.17 6.19164L19.8084 4.83001L19.3693 2.63492C19.3421 2.49321 19.2839 2.35925 19.1989 2.24263C19.1139 2.12601 19.0042 2.02959 18.8777 1.96026C18.1667 1.58183 17.4207 1.27344 16.65 1.03944C16.5113 0.998937 16.3652 0.989484 16.2224 1.01176C16.0795 1.03403 15.9433 1.08748 15.8235 1.16831L13.9629 2.40871H12.0372L10.1766 1.16831C10.0567 1.08748 9.9205 1.03403 9.77765 1.01176C9.63479 0.989485 9.48878 0.998938 9.34999 1.03944C8.57936 1.27344 7.83331 1.58183 7.12238 1.96025C6.99581 2.02958 6.88612 2.126 6.80113 2.24263C6.71613 2.35926 6.65794 2.49322 6.63071 2.63494L6.19178 4.8299L4.83003 6.19164L2.63505 6.63057C2.49334 6.65781 2.35939 6.71599 2.24277 6.80098C2.12614 6.88596 2.02972 6.99565 1.96039 7.12221C1.5819 7.83315 1.27347 8.57921 1.03943 9.34987C0.998933 9.48866 0.989485 9.63466 1.01176 9.77752C1.03403 9.92037 1.08749 10.0566 1.16832 10.1764L2.40872 12.0371V13.9627L1.16832 15.8233C1.08749 15.9432 1.03404 16.0794 1.01177 16.2223C0.989496 16.3651 0.998947 16.5111 1.03945 16.6499C1.27341 17.4206 1.5818 18.1666 1.96025 18.8776C2.02959 19.0041 2.12601 19.1138 2.24263 19.1988C2.35925 19.2838 2.4932 19.342 2.63491 19.3692L4.83003 19.8082L6.19166 21.1699L6.6306 23.365C6.65783 23.5067 6.71602 23.6406 6.801 23.7573C6.88598 23.8739 6.99567 23.9703 7.12222 24.0397C7.83312 24.4181 8.57916 24.7265 9.34979 24.9605C9.48858 25.001 9.63457 25.0104 9.77742 24.9882C9.92026 24.9659 10.0565 24.9124 10.1763 24.8316L12.0371 23.5912H13.9627L15.8234 24.8317C15.9433 24.9125 16.0795 24.966 16.2224 24.9882C16.3652 25.0105 16.5112 25.0011 16.65 24.9606C17.4207 24.7266 18.1667 24.4182 18.8776 24.0398C19.0041 23.9704 19.1138 23.874 19.1988 23.7574C19.2838 23.6408 19.342 23.5068 19.3692 23.3651L19.8083 21.17L21.1699 19.8082L23.365 19.3693C23.5067 19.3421 23.6406 19.2839 23.7573 19.1989C23.8739 19.1139 23.9703 19.0042 24.0396 18.8777C24.4181 18.1668 24.7266 17.4208 24.9606 16.6502C25.0011 16.5114 25.0105 16.3653 24.9883 16.2225C24.966 16.0796 24.9125 15.9434 24.8317 15.8236L23.5912 13.9628V12.0372Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

const PreviewIcon = () => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.8889 1C4.11111 1 1 8.00076 1 8.00076C1 8.00076 4.11111 15 11.8889 15C19.6667 15 22.7778 8.00076 22.7778 8.00076C22.7778 8.00076 19.6667 1 11.8889 1Z"stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M11.5 11.5C13.433 11.5 15 9.933 15 8C15 6.067 13.433 4.5 11.5 4.5C9.567 4.5 8 6.067 8 8C8 9.933 9.567 11.5 11.5 11.5Z"stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

const CheckoutIcon = () => {
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        fill="none"
        viewBox="0 0 28 25"
        stroke={"currentColor"}
        >
            <path d="M23.9877 24H3.77778C3.53168 24 3.29423 23.9093 3.11086 23.7451C2.92748 23.581 2.81107 23.355 2.78389 23.1104L1.00612 7.11043C0.990585 6.97065 1.00471 6.82917 1.04758 6.69522C1.09044 6.56127 1.16108 6.43787 1.25487 6.33308C1.34867 6.22828 1.46351 6.14445 1.59191 6.08706C1.7203 6.02967 1.85936 6 2 6H25.7655C25.9061 6 26.0452 6.02967 26.1736 6.08706C26.302 6.14445 26.4168 6.22828 26.5106 6.33308C26.6044 6.43787 26.675 6.56127 26.7179 6.69522C26.7608 6.82917 26.7749 6.97065 26.7594 7.11043L24.9816 23.1104C24.9544 23.355 24.838 23.581 24.6546 23.7451C24.4712 23.9093 24.2338 24 23.9877 24Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9 6C9 4.67392 9.52678 3.40215 10.4645 2.46447C11.4021 1.52678 12.6739 1 14 1C15.3261 1 16.5979 1.52678 17.5355 2.46447C18.4732 3.40215 19 4.67392 19 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14.7573 18.4852L18.9999 14.2426L14.7573 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9 14.2426H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

const PublishIcon = () => {
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        fill="none"
        viewBox="0 0 26 26"
        stroke={"currentColor"}
        >
          <path d="M8.45693 19.611C7.04272 23.8537 1.38586 23.8537 1.38586 23.8537C1.38586 23.8537 1.38586 18.1968 5.62851 16.7826M12.6996 18.1968L21.1849 9.71156C24.3979 6.49854 24.3665 3.28552 24.1621 1.91525C24.1306 1.70427 24.0322 1.50898 23.8814 1.35814C23.7306 1.20731 23.5353 1.10892 23.3243 1.07747C21.954 0.873024 18.741 0.841683 15.528 4.0547L7.04272 12.54M12.6996 18.1968L7.04272 12.54M12.6996 18.1968L13.7474 23.4357C13.7828 23.6132 13.8659 23.7777 13.9875 23.9117C14.1092 24.0457 14.2649 24.1442 14.4381 24.1967C14.6114 24.2491 14.7956 24.2536 14.9712 24.2095C15.1467 24.1655 15.3071 24.0747 15.435 23.9467L19.4778 19.904C19.5706 19.8111 19.6443 19.7009 19.6945 19.5795C19.7448 19.4582 19.7707 19.3282 19.7707 19.1969V11.1258M7.04272 12.54L1.80388 11.4922C1.6264 11.4567 1.46188 11.3737 1.32786 11.2521C1.19384 11.1304 1.09536 10.9747 1.04291 10.8014C0.990457 10.6282 0.986007 10.444 1.03003 10.2684C1.07406 10.0929 1.16491 9.93253 1.29289 9.80455L5.33561 5.76183C5.42847 5.66897 5.53871 5.59531 5.66004 5.54505C5.78136 5.4948 5.9114 5.46893 6.04272 5.46893H14.1138" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}
 
enum StepState {
    COMPLETED = "COMPLETED",
    ACTIVE =  "ACTIVE",
    INACTIVE =  "INACTIVE"
}

const getIconByName = (name) => {
    if (name === "TEMPLATE") {
        return <TemplateIcon />
    } else if (name === "CUSTOMIZE") {
        return <CustomizeIcon />
    } else if (name === "PREVIEW") {        
        return <PreviewIcon />
    } else if (name === "CHECKOUT") {
        return <CheckoutIcon />
    } else if (name === "PUBLISH") {
        return <PublishIcon />
    } 
}
const StepperCircle = ({isFirstStep, stepName, iconName, stepState}) => {
    return ( 
        <React.Fragment>
            <RenderIf condition={!isFirstStep}>
                <div className={`flex-auto border-t-2 transition duration-500 ease-in-out ${stepState === StepState.INACTIVE ? 'border-gray-300' : 'border-blue-700' }`}> </div>
            </RenderIf>
            <div className={`flex items-center relative ${ stepState === StepState.ACTIVE ? 'text-white' : stepState === StepState.COMPLETED ? 'text-blue-700' : 'text-gray-500' }`}>
                <div className={`rounded-full transition duration-500 ease-in-out h-12 w-12 py-3 border-2 ${stepState === StepState.ACTIVE ? 'bg-blue-700' : ''} ${ stepState === StepState.INACTIVE ? 'border-gray-300' : 'border-blue-700' }`}>
                    {getIconByName(iconName)}
                </div>
                <div className={`absolute top-0 -ml-10 text-center mt-14 w-32 text-xs font-medium uppercase ${stepState === StepState.INACTIVE ? 'xs:text-gray-500 text-transparent	' : 'xs:text-blue-700 text-transparent	'  }` }> {stepName} </div>
            </div>
        </React.Fragment>
    )
}

const Stepper = ({currentStep, steps}) => {
  return (
    <div className="mx-2 pb-4">
        <div className="flex items-center">
            <RenderIf condition={currentStep > 0} >
            {steps.slice(0,currentStep).map((step) => (
                <StepperCircle isFirstStep={step.label === 'Template' ? true : false} stepName={step.label} iconName={step.iconName} stepState={StepState.COMPLETED}/>
            ))}
            </RenderIf >

            <StepperCircle isFirstStep={ currentStep === 0 ? true : false} stepName={steps[currentStep].label} iconName={steps[currentStep].iconName} stepState={StepState.ACTIVE}/>
            
            <RenderIf condition={currentStep < steps.length - 1} >
                {steps.slice(currentStep + 1 - steps.length).map((step) => (
                    <StepperCircle isFirstStep={false} stepName={step.label} iconName={step.iconName} stepState={StepState.INACTIVE}/>
                ))}
            </RenderIf >
        </div>
    </div>
  )
}

export default Stepper


